import React, {Suspense, lazy} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {LayoutSplashScreen} from "../../../_metronic";
import EmailNaoVerificadoAlert from "../../components/EmailNaoVerificadoAlert";

const WelcomePage = lazy(() =>
    import("./welcome/WelcomePage")
);

const DashboardPage = lazy(() =>
    import("./dashboard/DashboardPage")
);

const PerfilPage = lazy(() =>
    import("./perfil/PerfilPage")
);

const GroupPage = lazy(() =>
    import("./group/GroupPage")
);

const AdminPage = lazy(() =>
    import("./admin/AdminPage")
);

const MotoristaPage = lazy(() =>
    import("./motorista/MotoristaPage")
);
const TracaoPage = lazy(() =>
    import("./tracao/TracaoPage")
);
const CarroceriaPage = lazy(() =>
    import("./carroceria/CarroceriaPage")
);

const FretePage = lazy(() =>
    import("./frete/FretePage")
);

const FreteAgendamentoPage = lazy(() =>
    import("./agendamento-frete/FreteAgendamentoPage")
);

const RelatorioPage = lazy(() =>
    import("./relatorio/RelatorioPage")
);

const LeilaoPage = lazy(() =>
    import("./leilao/LeilaoPage")
);

const OrcamentoPage = lazy(() =>
    import("./orcamento/OrcamentoPage")
);

const OfertaPage = lazy(() =>
    import("./oferta/OfertaPage")
);

const PainelOfertaPage = lazy(() =>
    import("./painel-oferta/PainelOfertaPage")
);

const TorrePage = lazy(() =>
    import("./torre/TorrePage")
);

const EmbarcadoraPage = lazy(() =>
    import("./embarcadora/EmbarcadoraPage")
);

const TransportadoraPage = lazy(() =>
    import("./transportadora/TransportadoraPage")
);

const TransportadorPage = lazy(() =>
    import("./transportador/TransportadorPage")
);

const AvaliacaoPage = lazy(() =>
    import("./avaliacao/AvaliacaoPage")
);

const UsuarioPage = lazy(() =>
    import("./usuario/UsuarioPage")
);

const DashboardPatioPage = lazy(() =>
    import("./dashboard-patio/DashboardPatioPage")
);

const ConfirmacaoPixPage = lazy(() =>
    import("./pix/ConfirmacaoPixPage")
);

const PatioPage = lazy(() =>
    import("./patio/PatioPage")
);

const ServicoEstacionamentoPage = lazy(() =>
    import("./servico-estacionamento/ServicoEstacionamentoPage")
);

const ServicoLimpezaPage = lazy(() =>
    import("./servico-limpeza/ServicoLimpezaPage")
);

const ServicoClassificacaoProduto = lazy(() =>
    import("./servico-classificacao-produto/ServicoClassificacaoProdutoPage")
);

const AgendamentosPage = lazy(() =>
    import("./agendamento/AgendamentosPage")
);

const DescontoPage = lazy(() =>
    import("./desconto/DescontoPage")
);

const ProdutoPage = lazy(() =>
    import("./produto/ProdutoPage")
);

const TipoCargaPage = lazy(() =>
    import("./tipo-carga/TipoCargaPage")
);

const ComposicaoVeicularPage = lazy(() =>
    import("./composicao-veicular/ComposicaoVeicularPage")
);

const CategoriaCargaAnttPage = lazy(() =>
    import("./categoria-carga-antt/CategoriaCargaAnttPage")
);

const UsuarioPatioPage = lazy(() =>
    import("./usuario-patio/UsuarioPatioPage")
);

const RelatorioPatioPage = lazy(() =>
    import("./relatorio-patio/RelatorioPatioPage")
);

const VagaMensalPage = lazy(() =>
    import("./vaga-mensal/VagaMensalPage")
);

const CodigoAcessoMotoristaPage = lazy(() =>
    import("./motorista/CodigoAcessoMotoristaPage")
);


export default function HomePage() {

    return (
        <Suspense fallback={<LayoutSplashScreen/>}>
            <EmailNaoVerificadoAlert />

            <Switch>
                <Route exact path="/" component={WelcomePage}/>

                <Route path="/dashboard" component={DashboardPage}/>
                <Route path="/perfil" component={PerfilPage}/>
                <Route path="/group" component={GroupPage}/>
                <Route path="/admin" component={AdminPage}/>
                <Route path="/motorista" component={MotoristaPage}/>
                <Route path="/tracao" component={TracaoPage}/>
                <Route path="/carroceria" component={CarroceriaPage}/>
                <Route path="/produto" component={ProdutoPage}/>
                <Route path="/tipo-carga" component={TipoCargaPage}/>
                <Route path="/composicao-veicular" component={ComposicaoVeicularPage}/>
                <Route path="/categoria-carga-antt" component={CategoriaCargaAnttPage}/>
                <Route path="/gestao-programacoes/lotes" component={FretePage}/>
                <Route path="/gestao-programacoes/programacoes" component={FreteAgendamentoPage}/>
                <Route path="/relatorio" component={RelatorioPage}/>
                <Route path="/leilao" component={LeilaoPage}/>
                <Route path="/orcamento" component={OrcamentoPage}/>
                <Route path="/oferta" component={OfertaPage}/>
                <Route path="/painel-oferta" component={PainelOfertaPage}/>
                <Route path="/torre" component={TorrePage}/>
                <Route path="/embarcadora" component={EmbarcadoraPage}/>
                <Route path="/transportadora" component={TransportadoraPage}/>
                <Route path="/proprietario-antt" component={TransportadorPage}/>
                <Route path="/avaliacao" component={AvaliacaoPage}/>
                <Route path="/usuario" component={UsuarioPage}/>

                {/* patio */}
                <Route exact path="/dashboard-patio" component={DashboardPatioPage}/>
                <Route path="/patio" component={PatioPage}/>
                <Route path="/servico/estacionamento" component={ServicoEstacionamentoPage}/>
                <Route path="/servico/limpeza" component={ServicoLimpezaPage}/>
                <Route path="/servico/classificacao-produto" component={ServicoClassificacaoProduto}/>
                <Route path="/desconto" component={DescontoPage}/>
                <Route path="/agendamento" component={AgendamentosPage}/>
                <Route path="/usuario-patio" component={UsuarioPatioPage}/>
                <Route path="/relatorio-patio" component={RelatorioPatioPage}/>
                <Route path="/pix" component={ConfirmacaoPixPage}/>
                <Route path="/vaga-mensal" component={VagaMensalPage}/>
                <Route path="/codigo-acesso-motorista" component={CodigoAcessoMotoristaPage}/>

                <Redirect to="/error/error-v6"/>
            </Switch>
        </Suspense>
    );
}
